import React from "react";
import styles from "./ThreeSensorIcons.scss";
import classNames from "classnames/bind";
import {
  TemperatureIcon,
  ChemicalsIcon,
  HumidityIcon
} from "../../components/index";

const cx = classNames.bind(styles);

const ThreeSensorIcons = () => {
  return (
    <div className={cx("ThreeSensorIcons")}>
      <ChemicalsIcon width={36} height={36} />
      <TemperatureIcon width={36} height={36} />
      <HumidityIcon width={36} height={36} />
    </div>
  );
};

export default ThreeSensorIcons;



// WEBPACK FOOTER //
// ./src/app/intro/components/ThreeSensorIcons/ThreeSensorIcons.js